import { useCallback, ReactElement } from 'react'
import { Modal, Spin } from 'antd'

import { deleteDecisionFolder } from '@vms/vmspro3-core/dist/actions/decision'

import { useAppDispatch } from '../../../redux'
import { useAccount } from '../../../context'
import { DecisionFolderLite } from '../../../types/decisionTypes'
import { useDecisionFolder2 } from '../../../hooks/useDecisionFolder2'

export type DecisionFolderDeleteModalProps = {
  decisionFolder: DecisionFolderLite
  hide: VoidFunction
}
export function DecisionFolderDeleteModal({ decisionFolder, hide }: DecisionFolderDeleteModalProps): ReactElement {
  const { accountId } = useAccount()
  const { data: folderData, loading } = useDecisionFolder2({
    decisionFolderId: decisionFolder.id,
    accountId,
  })
  const decisionFolderHasChildren = (folderData?.children?.length ?? 0) > 0

  const dispatch = useAppDispatch()
  const onOk = useCallback(() => {
    if (decisionFolderHasChildren) return
    dispatch(deleteDecisionFolder(decisionFolder.id))
    hide()
  }, [decisionFolderHasChildren, dispatch, decisionFolder.id, hide])

  return (
    <Modal
      open
      onOk={onOk}
      onCancel={hide}
      okButtonProps={{
        disabled: loading || decisionFolderHasChildren,
      }}
    >
      {loading ? (
        <Spin />
      ) : (
        <>
          <h3>Deleting {decisionFolder.name}</h3>
          <p>
            {decisionFolderHasChildren
              ? 'This folder has children and cannot be deleted. You must delete the contents ' +
                'of this folder before you can delete it.'
              : `Are you sure you want to delete ${decisionFolder.name}?`}
          </p>
        </>
      )}
    </Modal>
  )
}
